'use strict';

import { CONNECTOR as CONNECTOR_PERMISSION_GROUPS } from '../PermissionsGroups';

const connector_permissions_list = [];

for (const [key, value] of Object.entries(CONNECTOR_PERMISSION_GROUPS)) {
  connector_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const CONNECTOR = {
  can: connector_permissions_list,
};

export {
  CONNECTOR,
};
